// src/app/shared/utils/regex.utils.ts

/**
 * Matches basic Latin characters (ASCII): a-z, A-Z, numbers, and basic symbols.
 */
export const NAME_VALIDATION_REGEX = /^[a-zA-Z0-9.,'_ -]*$/;

export const NUMBER_INPUT_REGEX = {
    // Full value regex
    INTEGER_SIGNED: /^([+-]?\d*)$/,
    INTEGER_POSITIVE: /^([+]?\d*)$/,
    FLOAT_SIGNED: /^([+-]?\d*\.?\d+)$/,
    FLOAT_POSITIVE: /^(\d*\.?\d+)$/,

    // Strict (no plus sign)
    INTEGER_NO_PLUS: /^-?\d*$/,
    INTEGER_STRICT_POSITIVE: /^\d*$/, // no sign allowed
    FLOAT_NO_PLUS: /^-?\d*\.?\d+$/,
    FLOAT_STRICT_POSITIVE: /^\d*\.?\d+$/,

    // Key regex
    KEY_INTEGER_SIGNED: /[+\-0-9]/,
    KEY_INTEGER_POSITIVE: /[+0-9]/,
    KEY_INTEGER_NO_PLUS: /[-0-9]/,
    KEY_INTEGER_STRICT_POSITIVE: /[0-9]/,

    KEY_FLOAT_SIGNED: /[+\-0-9\.]/,
    KEY_FLOAT_POSITIVE: /[+0-9\.]/,
    KEY_FLOAT_NO_PLUS: /[-0-9\.]/,
    KEY_FLOAT_STRICT_POSITIVE: /[0-9\.]/,
};

export const STRING_INPUT_REGEX = {
    // Only ASCII characters
    ASCII_CHARACTER: /[^\x00-\x7F]/g,
};
export const TRIM_REGEX = {
    // Replace multiple spaces with single space
    TRIM: /\s{2,}/g,
};
